import { Routes, Route} from 'react-router-dom';
import {routes} from './routes';
import {useEffect} from "@wordpress/element";
import {useDispatch} from "react-redux";
import {fetchConfig} from "./features/config/configThunks";
import {fetchActiveTheme} from "./features/themes/themeThunks";


const App = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchConfig())
        dispatch(fetchActiveTheme())
    }, []);

    return (
        <Routes>
            {routes?.map((route, index) => <Route key={index} path={route.path} element={<route.element />} />)}
        </Routes>
    );
}

export default App;